import { APP_INITIALIZER, enableProdMode, Injector } from '@angular/core';
//import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

//import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient } from '@angular/common/http';
import { DEFAULT_LANGUAGE, MissingTranslationHandler, MissingTranslationHandlerParams, TranslateCompiler, TranslateDefaultParser, TranslateLoader, TranslateModule, TranslateParser, TranslateService, TranslateStore, USE_DEFAULT_LANG, USE_EXTEND, USE_STORE } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { JwtInterceptor } from 'src/core/interceptors/jwt-interceptor';
import { ErrorInterceptor } from 'src/core/interceptors/error.interceptor';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorI18n } from 'src/core/paginator/paginatorI8n';
import { VexConfigService } from 'src/@vex/config/vex-config.service';
import { LOCATION_INITIALIZED } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { LanguageInitializer } from './app/services/language-initializer.service';
import { pageLoadingInterceptor } from 'src/core/interceptors/page-loading.interceptor';


export function initializeLanguage(languageInitializer: LanguageInitializer) {
  return () => languageInitializer.init();
}
// Custom MissingTranslationHandler
class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: any) {
    console.warn(`Missing translation key: ${params.key}`);
    return params.key; // Fallback to key if translation is missing
  }
}

// Noop Compiler if no external compiler is needed
class CustomTranslateCompiler implements TranslateCompiler {
  compile(value: string): string {
    // Custom compilation logic (if needed)
    return value; // Return the value as is
  }

  compileTranslations(translations: any): any {
    // Custom logic to compile translations (if needed)
    return translations;
  }}


// Enable production mode if applicable
if (environment.production) {
  enableProdMode();
}

// Bootstrap the application
bootstrapApplication(AppComponent, {
  providers: [
    ...appConfig.providers,

    provideHttpClient(),
    
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),

    // Provide TranslateLoader
    {
      provide: TranslateLoader,
      useFactory: (http: HttpClient) => { return new TranslateHttpLoader(http, './assets/i18n/', '.json'); },
      deps: [HttpClient],
    },
    TranslateService,
    TranslateStore,
    
    // Provide TranslateCompiler
    {
      provide: TranslateCompiler,
      useClass: CustomTranslateCompiler ,
    },

    // Provide TranslateParser
    {
      provide: TranslateParser,
      useClass: TranslateDefaultParser,
    },

    // Provide MissingTranslationHandler
    {
      provide: MissingTranslationHandler,
      useClass: CustomMissingTranslationHandler,
    },

    // Configure translation options
    {
      provide: USE_DEFAULT_LANG,
      useValue: true, // Use default language
    },
    {
      provide: USE_STORE,
      useValue: false, // Disable state storage
    },
    {
      provide: USE_EXTEND,
      useValue: true, // Extend translations
    },
    {
      provide: DEFAULT_LANGUAGE,
      useValue: 'en', // Default language
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: pageLoadingInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeLanguage,
      deps: [LanguageInitializer,TranslateService],
      multi: true,
    },
    {
      provide: MatPaginatorIntl,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) =>
        new PaginatorI18n(translateService).getPaginatorIntl(),
    },
  ],
}).catch(err => console.error(err));